import React from "react"
import { Box, Container, HStack } from "@chakra-ui/react"

import CalloutTile from "@components/CalloutTile/CalloutTile"
import TileCarousel from "@components/TileCarousel/TileCarousel"
import Image from "@components/Image/Image"
import { useImage } from "@hooks/useImage"

export interface CampaignRowProps {
  images?: GatsbyTypes.SanityCustomImage[]
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  toggle?: "On" | "Off"
}

const CampaignRow = ({ images, carouselSettings, toggle }: CampaignRowProps) => {
  const { getGatsbyImage } = useImage()
  const campaignImages = images?.map(getGatsbyImage) || []

  return (
    <>
      <Container display={["block", "none"]} py={3.5} pr={0}>
        <TileCarousel spaceBetweenTiles={10} carouselSettings={carouselSettings}>
          {campaignImages.map(image => (
            <Box mb={3.5} key={image._key}>
              <Image key={image._key} {...image} width="205px" height="250px" />
            </Box>
          ))}
        </TileCarousel>
      </Container>
      <Container display={["none", "block"]}>
        <HStack spacing={2} py={4.5} justifyContent="center" alignItems="center">
          {campaignImages.map(image => (
            <CalloutTile key={image.key} image={image} size="medium" toggle={toggle} />
          ))}
        </HStack>
      </Container>
    </>
  )
}

export default React.memo(CampaignRow)
